import type { CustomerUserRole } from 'src/data/user';
// @ts-expect-error - useCurrentCustomers has no TypeScript declarations
import { useCurrentCustomers } from 'src/store/customer/useCurrentCustomers';
import { useSelectedCustomerId } from 'src/store/customer/useSelectedCustomerId';

export type ReviewerAccount = Pick<CustomerUserRole, 'id' | 'name'>;

export const useCurrentReviewerAccount = (): ReviewerAccount | null => {
  const currentCustomers: CustomerUserRole[] = useCurrentCustomers();
  const customerId = useSelectedCustomerId();

  return currentCustomers.find((customer) => String(customer.id) === customerId) ?? null;
};
